<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky">Спасибо!</h1>
                <div class="form-wrap__row">
                    <p class="content-text">{{appeal}} {{firstName}}. <br>
                        К сожалению в вашей заявке сегодня отказано.</p>
                </div>
                <div class="form-wrap__row">
                    <div class="form-button__wrap">
                        <router-link :to="{name: 'CabinetIndex'}" tag="button" class="form-button form-button--yellow form-button--long-text"> Перейти в личный кабинет </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import each from 'lodash/each';
    import {createHelpers} from 'vuex-map-fields';
    const {mapFields} = createHelpers({
        getterType: 'profile/getField',
        mutationType: 'profile/updateField',
    });

    export default {
        name: 'decline',
        metaInfo: {
            title: 'Регистрация'
        },
        data() {
            return {
            }
        },
        computed: {
            appeal: function () {
                return this.sex === 'MALE' ? 'Уважаемый' : 'Уважаемая'
            },
            ...mapFields([
                'firstName',
                'sex'
            ])
        },
        methods: {

        },
        mounted() {
            this.$store.dispatch('passportData/GET_PROFILE');
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";
    .content-text{
        color: $purple-site;
        font-size: 18px;
        font-family: $RobotoMedium;
        text-align: left;
        padding: 5px 15px;
    }
</style>